import * as React from 'react';
import { IShipFacet } from './ShipSearchBar';
import SelectButton from './SelectButton';
import { eventTracker } from '../../helpers/EventTracker/EventTracker';

interface IShipButton {
    type: string;
    facet: IShipFacet[];
    newSearch?: any;
    selectedFacet: IShipFacet;
    onChange: Function;
}

export const ShipOverviewButton = ({
    type,
    onChange,
    newSearch,
    selectedFacet,
    facet,
}: IShipButton) => {
    const onSelectClick = (facet) => {
        // if facet.id = -1, then no filtering for facet is needed (facet.id should be empty)
        facet.id = facet.id === -1 ? '' : facet.id;
        eventTracker.trackShipFilter(facet.label, type);
        onChange(type, facet);
        newSearch({
            [type]: facet.id,
        });
    };

    return (
        <SelectButton
            onSelectClick={(facet) => onSelectClick(facet)}
            options={facet}
            selectedFacet={selectedFacet}
        />
    );
};
